import ApiFetch from '../lib/ApiFetch';

export interface CrudConsumerInterface {
  get(arg1?: any, arg2?: any): Promise<Response> | void;
  post(arg1?: any, arg2?: any): Promise<Response> | void;
  delete(arg1?: any, arg2?: any): Promise<Response> | void;
  put(arg1?: any, arg2?: any): Promise<Response> | void;
}

abstract class CrudConsumer implements CrudConsumerInterface {
  constructor(readonly apiFetch: ApiFetch, readonly productType: string) {}

  get(arg1?: any, arg2?: any) {
    console.warn('NOT IMPLEMENTED\narguments: ', arg1, arg2);
  }
  post(arg1?: any, arg2?: any) {
    console.warn('NOT IMPLEMENTED\narguments: ', arg1, arg2);
  }
  delete(arg1?: any, arg2?: any) {
    console.warn('NOT IMPLEMENTED\narguments: ', arg1, arg2);
  }
  put(arg1?: any, arg2?: any) {
    console.warn('NOT IMPLEMENTED\narguments: ', arg1, arg2);
  }
}

export default CrudConsumer;
